// /* eslint-disable */

import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Avatar, Box, Button, ButtonGroup, Divider, Grid, IconButton, List, ListItemButton, Tooltip, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { AddRounded, EditRounded } from '@mui/icons-material';


import { useResponsiveStyles } from '../../utils/responsiveStyles';
import palette from '../../theme/palette';
import Key from '../../clientVariables.json';
import DetailsView from './DetailsView';
import AddCustomerSteps from './AddCustomerSteps';

const CustomersData = ({setAddCustomer, setEditCustomerData}) => {
  const currentUser = useSelector((state) => state.UserReducer.user);
  const [customerData, setCustomerData] = useState([]);
  const [customerDetailsData, setCustomerDetailsData] = useState(null);
  const styles = useResponsiveStyles();
  const [activeButton, setActiveButton] = React.useState('All');

  const handleButtonClick = (buttonName) => {
    setActiveButton(buttonName);
  };

  useEffect(() => {
    getCustomers();
    // if (customerData.length > 0) {
    //   // getCustomerDetails(customerData[0]?.userid);
    //   setCustomerDetailsData(customerData[0]);
    // }
  }, []);

  const getCustomers = async () => {
    try {
      const res = await axios.post(`${Key.domain}/dashboard/getCustomers`, {
        admin_id: currentUser?.id,
        session_token: currentUser?.session_token,
      });
      if (res.status === 200) {
        const newData = res.data.data;
        // console.log('newData', newData);
        setCustomerData(newData);
      setCustomerDetailsData(newData[0]);

      }
    } catch (error) {
      console.error(error);
    }
  };

  // const getCustomerDetails = async (id) => {
  //   try {
  //     const response = await axios.post(`${Key.domain}/customer/get_customerdetails`, {
  //       customer_id: id,
  //     });
  //     if (response.status === 200) {
  //       setCustomerDetailsData(response.data.data);
  //       console.log(response.data.data);
  //     }
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };

  const detailsHandler = (data, index) => {
    // getCustomerDetails(data?.userid);
    setCustomerDetailsData(data);
  }

  const buttonStyles = (buttonName) => ({
    borderRadius: '0px',
    p: '4px 15px',
    color: activeButton === buttonName ? palette.primary.main : palette.grey[600],
    backgroundColor: activeButton === buttonName ? palette.primary.lighter : 'transparent',
    borderColor: palette.grey[400],
    '&:hover': {
      backgroundColor: activeButton === buttonName ? palette.primary.light : palette.primary.lighter,
    //   borderColor: activeButton === buttonName ? 'primary.dark' : 'primary.main',
    },
    fontSize: styles.fontSize12
  });

  const text1Styles = {
    m:0, fontSize: styles.fontSize12, fontWeight:500, color:palette.grey[600]
}

  return (
    <Grid container spacing={0}>
        <Grid item xs={12}>
        <Button variant='outlined' size='small' sx={{mr: '8px'}}
        startIcon={<AddRounded /> }
        onClick={() => setAddCustomer(true)}>
        Add Customer
      </Button>
        <ButtonGroup variant="outlined" aria-label="Basic button group" size="small" sx={{mb:'6px'}}>
      <Button sx={buttonStyles('All')} onClick={() => handleButtonClick('All')}>All</Button>
      <Button sx={buttonStyles('Trail Period')} onClick={() => handleButtonClick('Trail Period')}>Trail Period</Button>
      <Button sx={buttonStyles('Monthly')} onClick={() => handleButtonClick('Monthly')}>Monthly</Button>
      <Button sx={buttonStyles('Yearly')} onClick={() => handleButtonClick('Yearly')}>Yearly</Button>
      <Button sx={buttonStyles('Custom')} onClick={() => handleButtonClick('Custom')}>Custom</Button>
    </ButtonGroup>
        </Grid>
      <Grid item xs={3.5}>
        {/* <Divider /> */}
        <Box>
          <List sx={{pr:'4px'}}>
            {customerData.map((data, index) => (
              <ListItemButton
              onClick={() => detailsHandler(data, index)}
               sx={{
                borderBottom: '1px solid #ddd',
                '.editButton': {
                  display:'none',
                },
                '&:hover': {
                  '.editButton': {
                    display:'block',
                  }
                }
              }}>
                <Box sx={{display: 'flex', flexDirection: 'column', gap: '10px', width:'100%'}}>
                  <Box sx={{ display: 'flex', gap: '6px' }}>
                    <Avatar />
                    <Box sx={{width:'100', flexGrow:1}}>
                      <Box sx={{display:'flex', width:'100%'}}>
                      <Typography paragraph 
                      sx={{ flexGrow:1,m: 0, fontWeight: 800, fontSize: styles.fontSize16, color: palette.grey[800], textTransform:'capitalize' }}>
                        {data?.user_name}
                      </Typography>
                      <Tooltip title='Edit Customer' followCursor>
                        <EditRounded className='editButton' 
                        onClick={() => setEditCustomerData(data)}
                        sx={{
                          height:styles.icon20, 
                          width: styles.icon20,
                          color: palette.grey[600],
                          bgcolor: '#fff',
                          }} />
                          </Tooltip>
                      </Box>
                      {/* <Typography paragraph sx={{...text1Styles}}>
                        California City, California
                    </Typography> */}
                      <Typography paragraph sx={{ ...text1Styles }}>
                        {data?.company_name}
                      </Typography>
                    </Box>
                  </Box>
                  <Box sx={{display:'flex', justifyContent:'space-between'}}>
                    <Box>
                      <Typography paragraph sx={{ m: 0, fontSize: styles.fontSize9 }}>
                        Enrolled Date
                      </Typography>
                      <Typography paragraph sx={{ m: 0, fontSize: styles.fontSize13 }}>
                      {moment(data?.package_start_date).format('LL')}
                      </Typography>
                    </Box>
                    <Box sx={{ border:'1px solid #ddd'}} />
                    <Box>
                      <Typography paragraph sx={{ m: 0, fontSize: styles.fontSize9 }}>
                        Billing Date
                      </Typography>
                      <Typography paragraph sx={{ m: 0, fontSize: styles.fontSize13 }}>
                      {moment(data?.package_end_date).format('LL')}
                      </Typography>
                    </Box>
                    <Box sx={{ border:'1px solid #ddd'}} />
                    <Box>
                      <Typography paragraph sx={{ m: 0, fontSize: styles.fontSize9 }}>
                        Subscription Daays
                      </Typography>
                      <Typography paragraph sx={{ m: 0, fontSize: styles.fontSize13 }}>
                        {data?.subscription_days} days
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </ListItemButton>
            ))}
          </List>
        </Box>
      </Grid>
      <Grid item xs={8.5}>
        <DetailsView selectedCustomer={customerDetailsData} />
      </Grid>
    </Grid>
  );
};

export default CustomersData;
